import { useState } from 'react';
import { Button } from '@accure/ui';
import { List, Map } from 'lucide-react';

import { cls } from '@/utils/cls';

import { SiteList } from '../site-list';
import { SiteListMapView } from '../site-list-map-view';

export function SiteSelector() {
  const [viewMode, setViewMode] = useState<'list' | 'map'>('list');

  function getProps(mode: 'list' | 'map') {
    if (viewMode === mode) {
      return {
        variant: 'secondary' as const,
        className: cls('transition-colors hover:bg-gray-100'),
      };
    } else {
      return {
        variant: 'ghost' as const,
        className: cls(
          'transition-colors hover:bg-gray-50 hover:text-gray-700',
        ),
      };
    }
  }

  return (
    <div className="w-full">
      <div className="mb-6 flex gap-3">
        <Button onClick={() => setViewMode('list')} {...getProps('list')}>
          <List className="size-5" />
          List View
        </Button>
        <Button onClick={() => setViewMode('map')} {...getProps('map')}>
          <Map className="size-5" />
          Map View
        </Button>
      </div>
      {viewMode === 'list' ? <SiteList /> : null}
      {viewMode === 'map' ? <SiteListMapView /> : null}
    </div>
  );
}
